'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function formatTimeDigit(num) {
  if (num < 10) {
    return '0' + num;
  }
  if (num > 59) {
    return '59';
  }
  return '' + num;
}

function formatTime(seconds) {
  var num = Math.round(seconds) || 0;
  return formatTimeDigit(Math.floor(num / 60)) + ':' + formatTimeDigit(num % 60);
}

exports['default'] = formatTime;
module.exports = exports['default'];